import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'user-folder-icon',
  templateUrl: './user-folder-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UserFolderIconComponent {}
